module.exports = __webpack_public_path__ + "static/media/79.2ead881e.jpg";